import classNames from 'classnames'
import { Link } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'

import { renderFormulas } from '../logic/formatting'
import { breadcrumbMetadata, BreadcrumbPart } from '../logic/ld-json'
import './Breadcrumbs.scss'

const Breadcrumbs = ({
  className,
  parts,
  siteUrl,
}: {
  className?: string
  parts: BreadcrumbPart[]
  siteUrl: string
}) => {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbMetadata(siteUrl, parts))}
        </script>
      </Helmet>
      <div className={classNames('breadcrumbs', className)}>
        {parts.map(({ internalLink, text }, i) => {
          const richFormulaText = renderFormulas(text)
          return (
            <React.Fragment key={i}>
              <span className="breadcrumbs__part">
                {i < parts.length - 1 ? (
                  <Link to={internalLink}>{richFormulaText}</Link>
                ) : (
                  richFormulaText
                )}
              </span>
              {i !== parts.length - 1 && (
                <span className="breadcrumbs__separator">{' / '}</span>
              )}
            </React.Fragment>
          )
        })}
      </div>
    </>
  )
}

export default Breadcrumbs
